import React from 'react';

import { CommentMedia } from './interfaces';

type GhostMap = Map<string, CommentMedia>;
type SetGhostMap = (updater: (prev: GhostMap) => GhostMap) => void;

function readFromStorage(key: string): GhostMap {
  try {
    const raw = localStorage.getItem(key);
    if (!raw) return new Map();
    return new Map(JSON.parse(raw) as [string, CommentMedia][]);
  } catch {
    return new Map();
  }
}

function writeToStorage(key: string, map: GhostMap) {
  try {
    if (map.size === 0) {
      localStorage.removeItem(key);
    } else {
      localStorage.setItem(key, JSON.stringify([...map.entries()]));
    }
  } catch {
    // localStorage indisponível (modo privado restrito etc.) — degradar silenciosamente
  }
}

export function useGhostMedias(commentId: string): [GhostMap, SetGhostMap] {
  const storageKey = `feedback-ghost-${commentId}`;

  const [cancelledMedias, setCancelledMediasRaw] = React.useState<GhostMap>(
    () => readFromStorage(storageKey),
  );

  const setCancelledMedias: SetGhostMap = React.useCallback(
    (updater) => {
      setCancelledMediasRaw((prev) => {
        const next = updater(prev);
        writeToStorage(storageKey, next);
        return next;
      });
    },
    [storageKey],
  );

  return [cancelledMedias, setCancelledMedias];
}
